import LocationMap from '../../LocationMap'
import { HomeDetails } from '../../HomeDetails'
import { Description } from '../../Description'
import { ThingsToNote } from '../../ThingsToNote'
import { StatusHeader } from '../../StatusHeader'
import { AddressSection } from '../../AddressSection'
import { ListingDetailsListing } from '../../../../../types/listings'
import { ListingProvidedByMlsName } from '../../../Compliance/ListingProvidedByMlsName'

import styles from './DesktopListingDetailsMainPanel.module.scss'

export interface DesktopListingDetailsMainPanelProps {
  listing: ListingDetailsListing
}

export const DesktopListingDetailsMainPanel = ({
  listing,
}: DesktopListingDetailsMainPanelProps) => {
  return (
    <div className={styles.mainPanel}>
      <ListingProvidedByMlsName listing={listing} />
      <div className={styles.section}>
        <StatusHeader listing={listing} />
        <AddressSection listing={listing} />
      </div>
      <Description listing={listing} className={styles.section} />
      <ThingsToNote listing={listing} className={styles.section} />
      <LocationMap listing={listing} className={styles.section} />
      <HomeDetails listing={listing} className={styles.section} />
    </div>
  )
}
